module.exports = __webpack_public_path__ + "static/img/img-3.6229c04a.png";